import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { productsData } from "../data/productdata";
import "../css/products.css";
import WhatsAppFloat from "../components/whatsapp";
import Footer from "../components/footer";

const categories = [
  "All",
  "Round",
  "Square",
  "Heart",
  "Kids",
  "Assortment",
  "Gift Boxes",
  "Slices",
];

const Products = () => {
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState(
    location.state?.category || "All",
  );
  const [sortOrder, setSortOrder] = useState("default");

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Update active category if location state changes while already on the page
  useEffect(() => {
    if (location.state?.category) {
      setActiveCategory(location.state.category);
    }
  }, [location.state]);

  // 1. Filter by category
  let processedProducts =
    activeCategory === "All"
      ? [...productsData]
      : productsData.filter((item) => item.category === activeCategory);

  // 2. Helper to clean currency strings into numbers
  const getPrice = (price) => {
    if (typeof price === "number") return price;
    return parseFloat(price.replace(/[^0-9.-]+/g, ""));
  };

  // 3. Sort logic
  if (sortOrder === "low-high") {
    processedProducts.sort((a, b) => getPrice(a.price) - getPrice(b.price));
  } else if (sortOrder === "high-low") {
    processedProducts.sort((a, b) => getPrice(b.price) - getPrice(a.price));
  }

  return (
    <section className="products-page">
      <Helmet>
        <title>Lovely Cakes | Cakes</title>
        <meta
          name="description"
          content="Browse our full collection of 35 beautifully handcrafted cakes. From vintage heart designs to modern squares, every cake is baked to order using simple, honest ingredients."
        />
        <meta
          name="keywords"
          content="order cakes Walsall, custom round cakes, vegan cakes, birthday cakes West Midlands, fresh baked cakes, cake menu"
        />
      </Helmet>

      <div className="products-header">
        <h1 className="display-title">Our Cakes</h1>
        <p className="header-desc">
          Browse our full collection of 35 seasonal and signature bakes. Each
          cake is made to order from scratch using simple, honest ingredients to
          bring a little extra joy to your special moments.
        </p>
      </div>

      {/* Seamless Filter Bar */}
      <div
        className="filter-bar"
        role="tablist"
        aria-label="Filter cakes by category"
      >
        {categories.map((category) => (
          <button
            key={category}
            role="tab"
            aria-selected={activeCategory === category}
            className={`filter-btn ${
              activeCategory === category ? "active" : ""
            }`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="sort-container">
        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          className="sort-dropdown"
          aria-label="Sort cakes by price"
        >
          <option value="default">Sort: Featured</option>
          <option value="low-high">Price: Low to High</option>
          <option value="high-low">Price: High to Low</option>
        </select>
      </div>

      <div className="product-grid">
        {processedProducts.map((item) => (
          <div key={item.id} className="product-item">
            <div className="product-image-container">
              {item.tag && <span className="product-tag">{item.tag}</span>}

              <Link
                to={`/cakes/${item.id}`}
                className="product-image-link"
                title={`View details for ${item.name}`}
              >
                <img
                  src={item.image}
                  alt={`${item.name} - Freshly baked ${item.category.toLowerCase()} cake from Lovely Cakes`}
                  className="product-image"
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Link>
            </div>

            <div className="product-info">
              <div className="product-meta">
                <span className="product-category">{item.category}</span>
                <span className="price">{item.price}</span>
              </div>
              <h3>
                <Link
                  to={`/cakes/${item.id}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {item.name}
                </Link>
              </h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* <WhatsAppFloat /> */}
      <Footer />
    </section>
  );
};

export default Products;
